import { ThunkDispatch as Dispatch } from 'redux-thunk';
import {
  AUTHENTICATE,
  IAuthCredentials,
  IAuthenticate,
  IUnauthenticate,
  UNAUTHENTICATE,
} from './types';
import AuthService from './auth-service';
import User from '../../models/User';

// loading state constants
export const SET_AUTH_LOADING = 'SET_AUTH_LOADING';

// loading state action interface
export interface ISetAuthLoading {
  type: typeof SET_AUTH_LOADING;
  isLoading: boolean;
}

export function setAuthLoading(isLoading: boolean): ISetAuthLoading {
  return {
    type: SET_AUTH_LOADING,
    isLoading,
  };
}

export function authenticate(user: User): IAuthenticate {
  return {
    type: AUTHENTICATE,
    user,
  };
}

export function unauthenticate(): IUnauthenticate {
  return {
    type: UNAUTHENTICATE,
    user: undefined,
  };
}

export type AuthenticationAction =
  | IAuthenticate
  | IUnauthenticate
  | ISetAuthLoading;

export function logIn(credentials: IAuthCredentials) {
  return async (
    dispatch: Dispatch<AuthenticationAction, {}, any>
  ): Promise<IAuthenticate | IUnauthenticate> => {
    dispatch(setAuthLoading(true));
    try {
      const user: User | undefined = await AuthService.logIn(credentials);
      return user ? dispatch(authenticate(user)) : dispatch(unauthenticate());
    } catch (error) {
      console.error('Login error', error);
      return dispatch(unauthenticate());
    } finally {
      dispatch(setAuthLoading(false));
    }
  };
}

export function logOut() {
  return async (
    dispatch: Dispatch<AuthenticationAction, {}, any>
  ): Promise<IUnauthenticate> => {
    dispatch(setAuthLoading(true));
    try {
      AuthService.logOut();
    } catch (error) {
      console.error('Error attempting to logout', error);
    } finally {
      dispatch(setAuthLoading(false));
      return dispatch(unauthenticate());
    }
  };
}

export function checkAuthentication() {
  return async (
    dispatch: Dispatch<AuthenticationAction, {}, any>
  ): Promise<IAuthenticate | IUnauthenticate> => {
    try {
      dispatch(setAuthLoading(true));
      const user: User | undefined = await AuthService.getLoggedInUser();
      if (user) {
        return dispatch(authenticate(user));
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setAuthLoading(false));
    }
    window.localStorage.removeItem('user');
    return dispatch(unauthenticate());
  };
}
